import React from "react";
import { Container, Typography, Box } from "@mui/material";

function About() {
  return (
    <Box id="about" sx={{ py: 8 }}>
      <Container>
        <Typography variant="h4" gutterBottom>
          About me
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: 900 }}>
          I am Madanapu Mohan Krishna, a Full‑Stack Developer with 4+ years of
          experience designing and developing robust web applications. I work
          across front‑end and back‑end Java, Spring Boot, React, and RESTful
          APIs delivering scalable solutions with clean architecture, strong
          performance, and user‑centric design. I’m comfortable owning features
          end‑to‑end, collaborating in agile teams, and deploying reliably to
          cloud environments.
        </Typography>
      </Container>
    </Box>
  );
}

export default About;
